import http from './http'

/**
 * 图库列表（unite49）
 * @param {string} site 站点标识
 * @param {string} lotteryType 玩法id（后端lotteryType/list返回的id）
 */
export function fetchUnite49PictureList(site, lotteryType) {
  return http.get('/api/pictures/unite49/list', {
    params: { site, lotteryType }
  })
}
